"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = require("../../../scripts/utils/color");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var colorScheme = _ref.colorScheme;
  var color0 = colorScheme.color0,
      color1 = colorScheme.color1,
      color2 = colorScheme.color2,
      color3 = colorScheme.color3,
      color4 = colorScheme.color4,
      color5 = colorScheme.color5;
  var COLOR_WHITE = '#ffffff';
  var DEFAULT_SECTION_ATOMS = {
    _section: {
      sectionMain: {
        backgroundColor: color4
      }
    }
  };
  var DEFAULT_ELEMENT_HEADER = {
    header: {
      main: {
        color: color1
      }
    }
  };
  return {
    header: {
      _section: {
        sectionMain: {
          backgroundColor: null
        }
      },
      eventName: {
        main: {
          color: color5
        }
      },
      registerButton: {
        main: {
          backgroundColor: color1,
          color: color5,
          borderColor: (0, _color.setAlpha)('#000000', 0)
        }
      },
      eventDate: {
        main: {
          color: color5
        }
      },
      eventVenue: {
        main: {
          color: color5
        }
      },
      eventSecondaryHeaders: {
        header1: {
          color: color5
        },
        header2: {
          color: color5
        }
      }
    },
    description: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      description: {
        main: {
          color: color3
        }
      }
    }),
    tickets: _objectSpread({
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      }
    }, DEFAULT_ELEMENT_HEADER),
    speakers: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      speakers: {
        main: {
          backgroundColor: color3
        },
        fullname: {
          color: COLOR_WHITE
        },
        text1: {
          color: COLOR_WHITE
        },
        text2: {
          color: COLOR_WHITE
        }
      }
    }),
    attendees: _objectSpread(_objectSpread({
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      }
    }, DEFAULT_ELEMENT_HEADER), {}, {
      attendees: {
        name: {
          color: color3
        },
        text1: {
          color: color1
        }
      },
      button: {
        main: {
          color: color5,
          backgroundColor: color1
        }
      }
    }),
    people: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        }
      },
      people: {
        text1: {
          color: color2
        },
        text2: {
          color: color3
        },
        text3: {
          color: color3
        }
      },
      header: {
        main: {
          color: color3
        }
      }
    },
    sponsors: {
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color2
        }
      },
      sponsors: {
        main: {
          color: '#595a5c'
        }
      }
    },
    exhibitors: {
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color2
        }
      },
      exhibitors: {
        main: {
          color: '#595a5c'
        }
      }
    },
    multiElement: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      header: {
        main: {
          color: color3
        }
      }
    }),
    form: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      form: {
        title: {
          color: color1
        },
        label: {
          color: color3
        },
        separator: {
          color: color3
        },
        button: {
          backgroundColor: color1,
          color: '#FFFFFF'
        },
        secondaryLabel: {
          color: color3
        }
      }
    }),
    buttons: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        }
      },
      eventButtons: {
        main: {
          backgroundColor: COLOR_WHITE,
          color: '#2BB0E9',
          borderColor: '#2BB0E9'
        }
      }
    },
    downloadApp: {
      _section: {
        sectionMain: {
          backgroundColor: color3
        },
        text: {
          color: color1
        },
        highlight: {
          color: color1
        }
      }
    },
    iframe: _objectSpread({}, DEFAULT_SECTION_ATOMS),
    countdownClock: _objectSpread(_objectSpread({
      _section: {
        sectionMain: {
          backgroundColor: color5
        }
      }
    }, DEFAULT_ELEMENT_HEADER), {}, {
      countdownClock: {
        main: {
          color: color1,
          borderColor: color1
        },
        text: {
          color: color1
        }
      }
    }),
    eventVenue: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ELEMENT_HEADER), DEFAULT_SECTION_ATOMS), {}, {
      eventVenue: {
        main: {
          color: color3
        }
      }
    })
  };
};

exports.default = _default;